import { cellPadding } from "@/common/constants";
import { cn } from "@/lib/utils";

interface CellButtonProps extends React.ComponentProps<"button"> {}

function CellButton({ children, className, ...props }: CellButtonProps) {
    return (
        <button
            type="button"
            className={cn(
                "appearance-none flex items-center gap-1 justify-start inset-0 w-full group/statuscolumn  curor",
                "[&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-3.5",
                "h-full",
                cellPadding,
                className
            )}
            {...props}
        >
            {children}
        </button>
    );
}

export default CellButton;
